import React, { useEffect, useState } from "react";
import {
  TextInput,
  Row,
  Column,
  FormGroup,
  RadioButtonGroup,
  RadioButton,
  TextArea,
  Checkbox,
} from "carbon-components-react";
import { Controller } from "react-hook-form";
import useGet from "../../hooks/useGet";
import ProvinceCombo from "../Combos/ProvinceCombo";
import DistrictCombo from "../Combos/DistrictCombo";
import GenericCombo from "../Combos/GenericCombo";

const ExistingBusinessProfileForm = ({
  disabled,
  register,
  control,
  errors,
  businessPlan,
}) => {
  const { data: legalForms } = useGet("/lookup/legal-forms");

  return (
    <FormGroup
      legendText="2. DADOS DOS SÓCIOS E INFORMAÇÕES DO NEGÓCIO  "
      className="section-header"
    >
      <h6 className="section-subtitle">
        2.1. Experiência e qualificação dos sócios-gestores/sócias-gestoras
      </h6>
      <div className="bx--form__helper-text">
        [Instrução de preenchimento: Descreva de forma breve, sem destacar o(s)
        nome(s), o perfil dos/as seus(as) sócios/as, identificando como sócio 1,
        sócio 2, assim em diante, considerando: (i) formação
        académica/vocacional completo e com certificado e (ii) número de anos de
        experiência profissional na área para a qual é apresentado este plano de
        negócios. Use no máximo 100 palavras.]
      </div>

      <fieldset className="bx--fieldset">
        <legend className="bx--label">Proprietário</legend>
        <Row>
          <Column sm={12} md={6} lg={6}>
            <TextInput
              id="ownerEducationLevel"
              labelText="(i) Escolaridade"
              disabled={disabled}
              {...register("ownerEducationLevel")}
            />
            <p className="field-error">{errors.ownerEducationLevel?.message}</p>
          </Column>
          <Column sm={12} md={6} lg={6}>
            <TextInput
              id="ownerExperienceYears"
              labelText="(ii) anos de experiência no negócio"
              min={0}
              disabled={disabled}
              {...register("ownerExperienceYears")}
            />
            <p className="field-error">
              {errors.ownerExperienceYears?.message}
            </p>
          </Column>
        </Row>
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12}>
            <TextArea
              id="ownerBusinessExperience"
              labelText="Descrição da Experiência no Negócio"
              rows={4}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 100 palavras.]"
              {...register("ownerBusinessExperience")}
            />
            <p className="field-error">
              {errors.ownerBusinessExperience?.message}
            </p>
          </Column>
        </Row>
      </fieldset>

      <fieldset className="bx--fieldset">
        <legend className="bx--label">Sócio 1</legend>
        <Row>
          <Column sm={12} md={6} lg={6}>
            <TextInput
              id="partner1EducationLevel"
              labelText="(i) Escolaridade"
              disabled={disabled}
              {...register("partner1EducationLevel")}
            />
            <p className="field-error">
              {errors.partner1EducationLevel?.message}
            </p>
          </Column>
          <Column sm={12} md={6} lg={6}>
            <TextInput
              id="partner1ExperienceYears"
              labelText="(ii) anos de experiência no negócio"
              min={0}
              disabled={disabled}
              {...register("partner1ExperienceYears")}
            />
            <p className="field-error">
              {errors.partner1ExperienceYears?.message}
            </p>
          </Column>
        </Row>
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12}>
            <TextArea
              id="partner1BusinessExperience"
              labelText="Descrição da Experiência no Negócio"
              rows={4}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 100 palavras.]"
              {...register("partner1BusinessExperience")}
            />
            <p className="field-error">
              {errors.partner1BusinessExperience?.message}
            </p>
          </Column>
        </Row>
      </fieldset>

      <fieldset className="bx--fieldset">
        <legend className="bx--label">Sócio 2</legend>
        <Row>
          <Column sm={12} md={6} lg={6}>
            <TextInput
              id="partner2EducationLevel"
              labelText="(i) Escolaridade"
              disabled={disabled}
              {...register("partner2EducationLevel")}
            />
            <p className="field-error">
              {errors.partner2EducationLevel?.message}
            </p>
          </Column>
          <Column sm={12} md={6} lg={6}>
            <TextInput
              id="partner2ExperienceYears"
              labelText="(ii) anos de experiência no negócio"
              min={0}
              disabled={disabled}
              {...register("partner2ExperienceYears")}
            />
            <p className="field-error">
              {errors.partner2ExperienceYears?.message}
            </p>
          </Column>
        </Row>
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12}>
            <TextArea
              id="partner2BusinessExperience"
              labelText="Descrição da Experiência no Negócio"
              rows={4}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 100 palavras.]"
              {...register("partner2BusinessExperience")}
            />
            <p className="field-error">
              {errors.partner2BusinessExperience?.message}
            </p>
          </Column>
        </Row>
      </fieldset>

      <h6 className="section-subtitle">
        2.2. Tipo de Negócio e Razões de Abertura
      </h6>
      <fieldset className="bx--fieldset required">
        <legend className="bx--label">2.2.1 Tipo de Negócio</legend>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              [Seleccione o tipo de negócio.]
            </div>
          </Column>
        </Row>
        <Row>
          <Column sm={12} md={3} lg={3}>
            <Controller
              name="isManufacturerOrProducer"
              control={control}
              render={({ field }) => (
                <Checkbox
                  labelText="Fabricante/Produtor "
                  id="isManufacturerOrProducer"
                  disabled={disabled}
                  checked={field.value || false}
                  onChange={(checked) => field.onChange(checked)}
                />
              )}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Controller
              name="isServiceProvider"
              control={control}
              render={({ field }) => (
                <Checkbox
                  labelText="Prestador de serviço "
                  id="isServiceProvider"
                  disabled={disabled}
                  checked={field.value || false}
                  onChange={(checked) => field.onChange(checked)}
                />
              )}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Controller
              name="isRetailer"
              control={control}
              render={({ field }) => (
                <Checkbox
                  labelText="Retalhista "
                  id="isRetailer"
                  disabled={disabled}
                  checked={field.value || false}
                  onChange={(checked) => field.onChange(checked)}
                />
              )}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Controller
              name="isWholesaler"
              control={control}
              render={({ field }) => (
                <Checkbox
                  labelText="Grossista/Vendedores a Grosso"
                  id="isWholesaler"
                  disabled={disabled}
                  checked={field.value || false}
                  onChange={(checked) => field.onChange(checked)}
                />
              )}
            />
          </Column>
          <p className="field-error">{errors.businessType?.message}</p>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required">
        <legend className="bx--label">
          2.2.2. Razões de Abertura do Negócio{" "}
        </legend>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              [Descreva as principais razões que o levaram a abrir este
              negócio.]
            </div>
          </Column>
        </Row>
        <Row>
          <Column sm={12} md={3} lg={3}>
            <Controller
              name="formalizationOfFamilyBusiness"
              control={control}
              render={({ field }) => (
                <Checkbox
                  labelText="Formalização do Negócio de Família"
                  id="formalizationOfFamilyBusiness"
                  disabled={disabled}
                  checked={field.value || false}
                  onChange={(checked) => field.onChange(checked)}
                />
              )}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Controller
              name="unemployment"
              control={control}
              render={({ field }) => (
                <Checkbox
                  labelText="Desemprego"
                  id="unemployment"
                  disabled={disabled}
                  checked={field.value || false}
                  onChange={(checked) => field.onChange(checked)}
                />
              )}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Controller
              name="marketOpportunity"
              control={control}
              render={({ field }) => (
                <Checkbox
                  labelText="Oportunidade de Mercado "
                  id="marketOpportunity"
                  disabled={disabled}
                  checked={field.value || false}
                  onChange={(checked) => field.onChange(checked)}
                />
              )}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Controller
              name="incomeDiversification"
              control={control}
              render={({ field }) => (
                <Checkbox
                  labelText="Diversificação da Renda "
                  id="incomeDiversification"
                  disabled={disabled}
                  checked={field.value || false}
                  onChange={(checked) => field.onChange(checked)}
                />
              )}
            />
          </Column>
          <p className="field-error">{errors.businessReason?.message}</p>
        </Row>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <TextArea
              id="businessOpeningReasonOther"
              labelText="Outras razões (especifique)"
              rows={3}
              enableCounter
              disabled={disabled}
              helperText="[Descreva outras razões que o levaram a abrir este negócio.]"
              {...register("businessOpeningReasonOther")}
            />
            <p className="field-error">
              {errors.businessOpeningReasonOther?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          2.3. Licenciamento da actividade que exerce{" "}
        </legend>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              Possui o Alvará ou outras licenças necessárias para a actividade
              que exerce actualmente?
            </div>
          </Column>
          <Column>
            <RadioButtonGroup
              name="hasPermitOrLicenses"
              disabled={disabled}
              valueSelected={businessPlan?.hasPermitOrLicenses}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="has-permit-y"
                {...register("hasPermitOrLicenses")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="has-permit-n"
                {...register("hasPermitOrLicenses")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.hasPermitOrLicenses?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              Possui a licença ambiental para as actividades do seu negócio?
            </div>
          </Column>
          <Column>
            <RadioButtonGroup
              name="hasEnvironmentalLicense"
              disabled={disabled}
              valueSelected={businessPlan?.hasEnvironmentalLicense}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="env-permit-y"
                {...register("hasEnvironmentalLicense")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="env-permit-n"
                {...register("hasEnvironmentalLicense")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.hasEnvironmentalLicense?.message}
            </p>
          </Column>
        </Row>
      </fieldset>

      <fieldset className="bx--fieldset legal-form">
        <legend className="bx--label">2.4 Forma Legal do Negócio </legend>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              [Seleccione a forma legal do seu negócio.]
            </div>

            <GenericCombo
              id="legalFormOfBusinessCode"
              name="legalFormOfBusinessCode"
              label="Selecione a forma legal do negócio"
              disabled={disabled}
              register={register}
              items={legalForms}
            />
            <p className="field-error">
              {errors.legalFormOfBusinessCode?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <h6 className="section-subtitle">
        2.5 Tipo de Produto(s)/Serviço(s) que produz/vende/oferece
      </h6>
      <p>
        Descreva de forma sumária, o(s) produto(s)/serviço(s) que actualmente
        produz/vende/ oferece e como são diferentes com os dos concorrentes. Use
        no máximo 100 palavras]
      </p>
      <fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="productServiceDescription"
              labelText="2.5.1.	Produto/serviços"
              rows={8}
              enableCounter
              disabled={disabled}
              {...register("productServiceDescription")}
            />
            <p className="field-error">
              {errors.businessProductOrService?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="competitorDifference"
              labelText="2.5.2.	Diferença com os dos concorrentes"
              rows={8}
              enableCounter
              disabled={disabled}
              {...register("competitorDifference")}
            />
            <p className="field-error">{errors.businessHistory?.message}</p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

ExistingBusinessProfileForm.defaultProps = {
  disabled: false,
};

export default ExistingBusinessProfileForm;
